import React, { useState, useEffect } from 'react';
import PubSub from 'pubsub-js'
import withSizes from 'react-sizes';
import { Checkbox } from '@rmwc/checkbox'

import Toggle from './Toggle'
import UnlockProCard from './UnlockProCard';
import LockIcon from './icons/LockIcon';
import CoinCard from './CoinCard';
import useDarkmode from '../hooks/useDarkmode';

import auth from '../services/auth'
import fetcher from '../services/fetcher'
import ga from '../services/ga'
import charts from '../services/charts'
import log from '../services/log'

import '@rmwc/switch/styles';
import ShareThisButtons from './ShareThisButtons';

function Heatmap(props){

  const [marketReportTweet, setMarketReportTweet] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState(null);
  //const [darkmode] = useDarkmode(props);

  const [selectedOptions, setSelectedOptions] = useState({
    symbols: true,
    moves: true,
    portfolio: true,
    alerts: true,
    rsi_1d: false
  });

  const toggleOptions = key => {
    ga.track({
      category: 'Retention',
      action: 'onHeatmapOptionsToggle',
      label: key
    })

    setSelectedOptions({
        ...selectedOptions,
        [key]: !selectedOptions[key]
    });
  }

  useEffect(() => {
      var token = PubSub.subscribe('COIN_SELECTED', (msg, data) => {
          ga.track({
            category: 'Retention',
            action: 'onHeatmapCoinSelected',
            label: data
          })

          //log.trace(msg);
          //log.traceTag('COIN_SELECTED', data)
          props.onCoinSelected(data);
      });

      return () => {
          //log.trace('unsubscribe');
          PubSub.unsubscribe(token);
      }
  });

  useEffect(() => {
      var token = PubSub.subscribe('HEATMAP_COIN_CARD_SELECTED', (msg, coin) => {
          setSelectedCoin(coin);
      });

      return () => {
          PubSub.unsubscribe(token);
      }
  }, []);

  useEffect(() => {
    log.traceTag('props.showOnlyPortfolio', props.showOnlyPortfolio)
    log.traceTag('selectedOptions', selectedOptions)
    log.traceTag('heatmap darkmode', props.darkmode)
    charts.init('heatmap')
    charts.rsi(props.coins, props.portfolio, props.filters, props.alerts, props.isMobile, selectedOptions, props.indicators, props.darkmode)
    charts.refreshSize()

  }, [props.coins, props.filters, selectedOptions, props.darkmode]);

  useEffect(() => {
    setSelectedCoin(null);
  }, [props.filters, selectedOptions]);

  useEffect(() => {
    return () => {
      charts.destroy()
    }
  }, []);

  return (
    <>
      {props.showToggle && 
        <div className="row mb-1">
          <div className="col-12">
          <span className="float-left">
            <span className='text-muted small hide-small'>Show:&nbsp;</span>
            <span>
            <Toggle
              checked={selectedOptions['symbols']}
              onClick={evt => {
                toggleOptions('symbols')
              }}
            >
            Symbols
          </Toggle>
          &nbsp;
            </span>
          <span className="hide-small">
            <Toggle
              checked={selectedOptions['moves']}
              onClick={evt => toggleOptions('moves')}
            >
              <span className="hide-small">Price&nbsp;</span>Moves
            </Toggle>
            &nbsp;
          </span>
          <Toggle
            checked={selectedOptions['portfolio']}
            onClick={evt => toggleOptions('portfolio')}
          >
            Portfolio
          </Toggle>
          &nbsp;
          <Toggle
            checked={selectedOptions['alerts']}
            onClick={evt => toggleOptions('alerts')}
          >
            24h Alerts
          </Toggle>
          &nbsp;
          {/*
          {<span className="small text-muted hide-small">Share:&nbsp;</span>}
          {props.indicators.marketReport &&
            <ShareThisButtons title={props.indicators.marketReport}  >
            </ShareThisButtons>
          }*/}
          </span>
            <span className='float-right'>
            <span className="small text-muted hide-small">&nbsp;&nbsp;Set RSI Interval (4h/1D):&nbsp;</span>
            <Toggle
                className="inline-flex items-center"
                checked={selectedOptions['rsi_1d']}
                onClick={() => {
                  if (!auth.isUnlocked()) {
                    auth.showUnlockDialog();
                  } else {
                    toggleOptions('rsi_1d');
                  }
                }}
              >
                <span className="inline-flex items-center gap-2 whitespace-nowrap align-middle">
                  {!auth.isUnlocked() && (
                    <LockIcon
                      color={props.darkmode ? 'white' : 'black'}
                      size={14}
                    />
                  )}

                  <span>
                    {selectedOptions['rsi_1d'] ? 'RSI 1D' : 'RSI 4h'}
                  </span>
                </span>
              </Toggle>
            </span>
          </div>
        </div>
      }
      {!auth.isUnlocked() && !props.landing &&
        <div className="row">
          <div className="col-12">
            <UnlockProCard text={'Unlock Full Access to RSI Heatmap'}></UnlockProCard>
          </div>
        </div>
      }
      {/*show heat map on landing always */}
      {props.landing &&
        <div className={auth.isFreeTrial() ? '' : ''} style={{height: 80+'vh', minHeight: (props.isMobile) ? 800+'px' : 800+'px'}}>
            <div id="heatmap" style={{'height': 100+'%', 'width': 100+'%'}}></div>
        </div>
      }
      {/* Always show heatmap even after trial */}
      {!props.landing &&
        <div className={auth.isUnlocked() ? '' : ''} style={{position: 'relative', height: 80+'vh', minHeight: (props.isMobile) ? 800+'px' : 800+'px'}}>
          {/*<div id="share_heatmap" className='share-heatmap'>
            {props.indicators.marketReport &&
              <ShareButtons title={props.indicators.marketReport} size={32} >
              </ShareButtons>
            }
          </div>*/}
          <div id="heatmap" style={{'height': 100+'%', 'width': 100+'%'}}></div>
        </div>
      }
      {!props.landing && props.isMobile && selectedCoin &&
        <div className="row mt-3 mb-2">
          <div className="col-12">
            <CoinCard
              coin={selectedCoin}
              isMobile={props.isMobile}
              displayRsiPeriod={selectedOptions.rsi_1d ? '1d' : '4h'}
              onCoinSelected={(coinSymbol) => {
                props.onCoinSelected(coinSymbol)
              }}
            />
          </div>
        </div>
      }
    </>
  );
};

Heatmap.defaultProps = {
  showToggle: true,
  filters: {
    sort: {
      rank: [1,0],
      _1h: [0,0],
      _24h: [0,0],
      _7d: [0,0],
      _30d: [0, 0],
      rsi: [0,0],
      rsi_1d: [0,0],
    },
    view: {
      list: false,
      heatmap: true,
      alerts: false
    },
    search: ''
  }
};


const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})

export default withSizes(mapSizesToProps)(Heatmap);
